getSSRObservable